import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { auth, functions } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import Login from "./pages/Login";
import Layout from "./pages/Layout";
import FerienlagerAnmeldung, { REGISTRIERUNG_URL } from "./pages/FerienlagerAnmeldung";

const syncMeinenAdminClaim = httpsCallable(functions, "syncMeinenAdminClaim");

function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      if (u) {
        // Rolle als Custom Claim ins Token spiegeln, damit z.B. die Storage-Regeln
        // (Datei-Anhänge, Screenshots) die Admin-Rolle zuverlässig prüfen können.
        try {
          await syncMeinenAdminClaim();
          await u.getIdToken(true);
        } catch (err) {
          console.error("Admin-Claim-Sync fehlgeschlagen:", err.message);
        }
      }
      setUser(u);
    });
    return unsubscribe;
  }, []);

  if (user === undefined) return <div style={{ padding: "2rem" }}>Laden...</div>;

  return (
    <BrowserRouter>
      <Routes>
        {/* Öffentlich, ohne Login erreichbar – das eigentliche Anmeldeformular für Teilnehmer:innen */}
        <Route path={REGISTRIERUNG_URL} element={<FerienlagerAnmeldung />} />
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
        <Route path="/*" element={user ? <Layout user={user} /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
